export enum ButlerUnitedVertical {
  TAXI_BUTLER = 'TAXI_BUTLER', VENUE_BUTLER = 'VENUE_BUTLER'
}